import { render, staticRenderFns } from "./keto.vue?vue&type=template&id=a8079dee"
import script from "./keto.vue?vue&type=script&lang=js"
export * from "./keto.vue?vue&type=script&lang=js"
import style0 from "./keto.vue?vue&type=style&index=0&id=a8079dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports